import { type DataForParent, microFrontListener } from '@b2ag/micro-front-tools'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { PAGE_TYPE, PAGE_ANALYTICS_INFO } from '../page-types'
import { callbacksFromLegalsMicroFrontIframe } from '../../contexts/legals'

/* ------- MICROFRONT - LEGALS ------- */

export const legalsMainRoutes = [
  {
    path: '/general-conditions-use',
    name: 'legals',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => ({
      microFrontName: 'legals',
      viewName: 'cgu',
    }),
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
      showAppFooter: true,
    },
  },
  {
    path: '/privacy-policy',
    name: 'privacy',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => ({
      microFrontName: 'legals',
      viewName: 'privacy',
    }),
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
      showAppFooter: true,
    },
  },
  {
    path: '/legals',
    name: 'legal-notice',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => ({
      microFrontName: 'legals',
      viewName: 'legal-notice',
    }),
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
      showAppFooter: true,
    },
  },
  {
    path: '/general-terms-and-conditions',
    name: 'cgv',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => {
      return {
        microFrontName: 'legals',
        viewName: 'cgv',
        cooperativeId: useStore().getters.currentCooperativeId,
      }
    },
    beforeEnter() {
      if (import.meta.browser)
        microFrontListener({
          iframe: { href: window.location.origin },
          router: useRouter() as any,
        })
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
      showAppFooter: true,
    },
  },
]

export const legalsTechRoutes = [
  {
    path: '/accept-gcu',
    name: 'accept-cgu-tech',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => ({
      microFrontName: 'legals',
      viewName: 'accept-cgu',
    }),
    beforeEnter(_, __, next) {
      const router = useRouter()
      if (useStore()?.getters.isCGUAccepted) {
        next({ name: 'home' })
      } else {
        microFrontListener({
          iframe: { href: window.location.origin },
          callbackForMessages: (data: DataForParent) => callbacksFromLegalsMicroFrontIframe(data, router),
          router: router as any,
        })
        next()
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CGU,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.CGU,
      layout: 'minimal',
    },
  },
]
